import { hideOnClickOutside } from '../utils/utils';
import GSAP from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

GSAP.registerPlugin(ScrollTrigger)

export default class Nav {
	constructor() {
		this.nav 		= document.querySelector(".nav");
		this.icon 		= document.querySelector(".btn--menu");
		this.buttons 	= document.querySelectorAll(".nav__button--parent .nav__link");
		this.sticky 	= this.sticky.bind(this)
		this.cumulativeScrollDifference = 0;

		this.icon &&
			this.icon.addEventListener("click", (event) => {
				event.preventDefault();
				document.querySelector("body").classList.toggle("nav--open");
				document.querySelector("body").classList.add("nav--filled");
			});

		this.buttons &&
			this.buttons.forEach((button)=>{
				button.addEventListener("click", (event) => {
					event.target.parentNode.classList.toggle("nav__link--open")
					document.body.classList.add("nav--open","nav--filled");
					// document.body.classList.add("nav--expanded");
					if( window.innerWidth > 877 ){
						hideOnClickOutside( event.target.parentNode, ['nav--expanded','nav--open'], 'nav__link--open' )
					}
				});
			})

		document.addEventListener('scroll', this.sticky.bind(this));
		
	}

	sticky()
	{

		// CREATING GSAP ANIMATION FOR HIDING THE NAV USING yPERCENT
		this.yTransform = GSAP.utils.pipe( 
			GSAP.utils.clamp(-110, 0),
			GSAP.utils.snap(1),
			GSAP.quickSetter( this.nav, "yPercent" )
		)

		// DETECTING SCROLL DIRECTION
		let navHeight = document.querySelector('.nav').offsetHeight;
		let triggerHeight = 100;
		let currentScroll = window.app.scrollTop;
		let topMargin = window.innerHeight;

		if (currentScroll > 0)
		{
			// this.currentScrollDifference = currentScroll - this.scrollPos;
			let newScrollDifference = currentScroll - this.scrollPos;
			// console.log('newscrolldiff: ' + newScrollDifference)
			// console.log( window.app.nav.cumulativeScrollDifference )
			// console.log( 'currentScroll: ' + currentScroll )
			// console.log( 'scrollPos: ' + this.scrollPos )
			
			if (currentScroll <= this.scrollPos) 
			{
				// SCROLLING UP
				window.app.nav.cumulativeScrollDifference = GSAP.utils.clamp( -110, 0, (window.app.nav.cumulativeScrollDifference - newScrollDifference) );
				this.yTransform( window.app.nav.cumulativeScrollDifference )
			} else {
				// SCROLLING DOWN
				window.app.nav.cumulativeScrollDifference = GSAP.utils.clamp( -110, 0, (window.app.nav.cumulativeScrollDifference - newScrollDifference) );
				this.yTransform( window.app.nav.cumulativeScrollDifference )
			}
		}

		// TOGGLING NAV STYLE AFTER TRIGGER POINT
		if (currentScroll > triggerHeight) 
		{
			document.body.classList.add("nav--filled");
			document.body.classList.remove("nav--expanded");
			document.body.classList.remove("nav--open");
			this.buttons.forEach((button)=>{
				button.parentNode.classList.remove('nav__link--open')
			})
		} else 
		{
			document.body.classList.remove("nav--filled");
		}
		
		this.scrollPos = window.app.scrollTop;
	}
}
